import React from "react";
import { Control, Controller } from "react-hook-form";
import Dropzone from "../base/Dropzone";

interface Props {
  control: Control<any, any>;
  fieldName: string;
  required?: boolean;
  onChange?: (value: any) => void;
}

const FormDropzone: React.FC<Props> = (props) => {
  const { control, fieldName, onChange } = props;

  const handleOnChange = (value: any) => {
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field: { onChange } }) => (
        <Dropzone
          onDrop={(e) => {
            onChange(e[0]);
            handleOnChange(e[0]);
          }}
        />
      )}
    />
  );
};

export default FormDropzone;
